import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// ✅ this is the correct import

dayjs.extend(utc);
dayjs.extend(timezone); // ✅ this should be "timezone", not "timezonePlugin"

export const convertToUTC = ({ day, start_time, timezone, spans_next_day }) => {
    const dayIndex = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].indexOf(day);

    const base = dayjs().startOf('week').add(dayIndex, 'day'); // This week's Monday, for example

    const startLocal = dayjs.tz(`${base.format('YYYY-MM-DD')}T${start_time}`, timezone);
    const endLocal = spans_next_day
        ? startLocal
              .add(1, 'day')
              .set('hour', parseInt(end_time.split(':')[0]))
              .set('minute', parseInt(end_time.split(':')[1]))
        : dayjs.tz(`${base.format('YYYY-MM-DD')}T${end_time}`, timezone);

    return {
        start_utc: startLocal.utc().format(), // ISO string
        end_utc: endLocal.utc().format(),
    };
};

export const generateTimeOptions = (gap = 15) => {
    const times = [];

    if (gap < 1) {
        return [];
    }
    for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += gap) {
            const label = dayjs().hour(h).minute(m).format('h:mm A');
            const value = dayjs().hour(h).minute(m).format('HH:mm');
            times.push({ label, value });
        }
    }

    return times;
};

export const formatAvailabilityFromUTC = (availability) => {
    const start = dayjs.utc(availability.start_datetime); // UTC
    const end = dayjs.utc(availability.end_datetime);

    const day = start.format('dddd'); // e.g., "Monday"
    const startTime = start.format('h:mm A'); // e.g., "10:00 PM"
    const endTime = end.format('h:mm A'); // e.g., "1:00 AM"

    return { day, startTime, endTime };
};

export const formatAvailabilityForUI = ({ day, start_time, end_time, spans_next_day }) => {
    const startLabel = formatTimeForLabel(start_time); // e.g., "9:00 PM"
    const endLabel = formatTimeForLabel(end_time); // e.g., "1:00 AM"

    const endDay = spans_next_day
        ? dayjs()
              .day(dayIndex(day) + 1)
              .format('dddd')
        : day;

    return `${day} ${startLabel} - ${endLabel}${spans_next_day ? ` (${endDay})` : ''}`;
};

const dayIndex = (day) => ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].indexOf(day);
